<template>
    <div class="news-warp">
        <page-nav class="page-nav" :isJump="true"></page-nav>
        
        <div class="news-container">
            <div class="news-content">
                <div class="news-tag-box">
                    <ul class="news-tag-ul">
                        <li 
                        class="news-tag-li" 
                        :class="{ 'active': tagId === tag.id }" 
                        v-for="(tag, index) in tagList" 
                        :key="`tag-li-${index}`"
                        @click="pickTag(tag)"
                        >{{ tag.text }}</li>
                    </ul>
                </div>
                <div class="news-box-wrap" :class="{ 'hideborder': totalNum == 0 }">
                    <router-link :to="routerTo(item)" target="_blank" class="news-box" :class="{ 'place': !item }"
                        v-for="(item, index) in newsList" :key="`news-box-${index}`">
                        <div class="news-inner" v-if="item">
                            <p class="news-row">
                                <span class="news-tag">{{ tagMap[item.category] }}</span>
                                <span class="news-time">{{ $utils.formatTime(item.publishedAt) }}</span>
                            </p>
                            <p class="news-title">{{ item.title }}</p>
                            <p class="news-more">READ MORE +</p>
                        </div>
                    </router-link>
                </div>
                <div class="news-pagenav-wrap">
                    <div class="pre-button" :class="{ 'place': currentPageNum == 1}" @click="prePage">
                        <i class="iconfont iconchangyongtubiao-xianxingdaochu-zhuanqu-"></i>
                        <span>Previous</span>
                    </div>

                    <div class="pagenav-button-content">
                        <pagination :total-page-num="pageTotalNum" :max-page-num="maxPageNum"
                            :cur-page-num.sync="currentPageNum" @jumpPage="jumpPage"></pagination>
                    </div>

                    <div class="next-button" :class="{ 'place': currentPageNum >= pageTotalNum}" @click="nextPage">
                        <span>Next</span>
                        <i class="iconfont iconchangyongtubiao-xianxingdaochu-zhuanqu-"></i>
                    </div>
                </div>
            </div>
        </div>
        <footer-bar class="footerbar"></footer-bar>
    </div>
</template>

<script>
import pageNav from "../components/nav"
import {mapState, mapGetters} from 'vuex'
import FooterBar from "../components/footer.vue";
import pagination from "../components/Pagination"
export default {
    name: "news",

    components: {
        FooterBar,
        pageNav,
        pagination
    },
    data: () => ({
        tagList: [
            {
                id: undefined,
                text: 'LATEST'
            },
            {
                id: 3,
                text: 'EVENT'
            },
            {
                id: 2,
                text: 'CONTEST'
            },
            /* {
                id: 4,
                text: 'ANNOUNCEMENT'
            } */
        ],
        newsList: [],
        tagId: 2,    // 当前新闻类别id
        currentPageNum: 1,
        totalNum: 0,
        maxPageNum: 5
    }),
    created() {
        this.getNews()
    },
    mounted() {
    },
    watch: {

    },
    computed: {
        ...mapState({
			NAVLIST: state => state.Home.NAVLIST
		}),
        tagMap() {
            let map = {}
            for(let i = 0, len = this.tagList.length; i < len; i++) {
                map[this.tagList[i].id] = this.tagList[i].text
            }
            return map
        },
        pageTotalNum() {
            return Math.ceil(this.totalNum/9);
        }
    },
    methods: {
        pickTag(tag) {
            this.tagId = tag.id
            this.currentPageNum = 1
            this.getNews()
        },
        getNews() {
            this.axios.get(`${process.env.VUE_APP_NEWS_HOST}/news`, {
                params: {
                    lang: "en",
                    category: this.tagId,
                    limit: 9,
                    page: this.currentPageNum
                }
            }).then(v => {
                this.totalNum = v.data.data.total
                if(v.data.data.items.length > 9) {
                    this.newsList = v.data.data.items.slice(0, 9)
                } else if(v.data.data.items.length < 9) {
                    let newslist = v.data.data.items
                    newslist.length = 9
                    this.newsList = newslist
                } else {
                    this.newsList = v.data.data.items
                }
            }).catch(e => {
                console.log(e)
            })
        },
        prePage() {
            this.currentPageNum -= 1
            this.getNews()
        },
        nextPage() {
            this.currentPageNum += 1
            this.getNews()
        },
        jumpPage(index) {
            this.currentPageNum = index
            this.getNews()
        },
        routerTo(item) {
            if(item && item.id) {
                return `/news/${item.id}`
            } else {
                return '/news'
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.news-warp {

    .page-nav {
        position: absolute;
        z-index: 4;
        top: pxTorem(20px);
        left: pxTorem(12px);
    }
    
    .news-container {
        position: absolute;
        width: 100%;
        height: 100%;
        background: url("../assets/images/news/bg.jpg") no-repeat;
        background-size: cover;
        background-position: center;
        @include customScrollBar;

        .news-content {
            position: absolute;
            width: pxTorem(1300px);
            box-sizing: border-box;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);

            .news-tag-box {
                width: 100%;
                height: pxTorem(45px);
                border: 1px solid #535353;
                box-sizing: border-box;
                display: flex;
                justify-content: flex-end;
                margin-bottom: pxTorem(23px);
                
                .news-tag-ul {
                    display: flex;
                    height: 100%;
                    
                    .news-tag-li {
                        height: 100%;
                        line-height: pxTorem(45px);
                        font-family: 'STHeiti', sans-serif;
                        font-size: pxTorem(24px);
                        font-weight: bold;
                        color: #898989;
                        padding: 0 pxTorem(18px);
                        cursor: pointer;

                        &.active {
                            background: #22bbff;
                            color: #000;
                        }
                    }
                }
            }

            .news-box-wrap {
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                border-top: 1px solid #535353;
                margin-bottom: pxTorem(20px);

                .news-box {
                    width: 33.33%;
                    height: 0;
                    padding-top: 16.66%;
                    border-right: 1px solid #535353;
                    border-bottom: 1px solid #535353;
                    box-sizing: border-box;
                    position: relative;

                    &:nth-of-type(3n+1) {
                        border-left: 1px solid #535353;
                    }

                    .news-inner {
                        width: 100%;
                        height: 100%;
                        position: absolute;
                        top: 0;
                        left: 0;
                        box-sizing: border-box;
                        padding: pxTorem(25px);
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        cursor: pointer;
                        transition: all .3s ease-in-out;

                        .news-row {
                            font-size: 0;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            
                            .news-tag {
                                color: #22bbff;
                                font-family: "STHeiti";
                                font-size: pxTorem(24px);
                                font-weight: bold;
                            }
                            .news-time {
                                color: #898989;
                                font-size: pxTorem(24px);
                                font-family: "Bender";
                            }
                        }
                        .news-title {
                            width: 100%;
                            font-size: pxTorem(20px);
                            font-family: "SourceHanSansSubset";
                            color: #fff;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;

                            &::before {
                                content: "";
                                display: block;
                                width: pxTorem(65px);
                                height: pxTorem(8px);
                                background: #22bbff;
                                margin-bottom: pxTorem(20px);
                            }
                        }
                        .news-more {
                            width: pxTorem(166px);
                            height: pxTorem(24px);
                            background: #22bbff;
                            color: #141515;
                            font-family: "Bender";
                            font-size: pxTorem(18px);
                            line-height: pxTorem(24px);
                            align-self: flex-end;
                            text-align: right;
                            box-sizing: border-box;
                            padding-right: pxTorem(10px);
                        }

                        &:hover {
                            background: #22bbff;
                            .news-row {
                                .news-tag {
                                    color: #000000;
                                }
                                .news-time {
                                    color: #000;
                                }
                            }
                            .news-title {
                                &::before {
                                    background: #000;
                                }
                            }
                            .news-more {
                                background: #141515;
                                color: #fff;
                            }
                        }
                    }

                    &.place {
                        visibility: hidden;
                    }
                }

                &.hideborder {
                    border: none;
                }
            }

            .news-pagenav-wrap {
                width: 100%;
                height: pxTorem(43px);
                display: flex;
                justify-content: space-between;

                .pre-button, .next-button {
                    border: 1px solid #22bbff;
                    width: pxTorem(160px);
                    box-sizing: border-box;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    color: #fff;
                    font-size: 0;
                    cursor: pointer;
                    transition: all .1s ease-in-out;

                    .iconfont {
                        font-size: pxTorem(18px);
                        line-height: 1;
                    }
                    span {
                        font-size: pxTorem(16px);
                        line-height: 1;
                    }

                    &.pre-button {
                        .iconfont {
                            transform: scale(-1, 1);
                            margin-right: pxTorem(15px);
                        }
                    }
                    &.next-button {
                        .iconfont {
                            margin-left: pxTorem(15px);
                        }
                    }
                    &.place {
                        visibility: hidden;
                    }
                    
                    &:hover {
                        background: #22bbff;
                        color: #000;
                    }
                }

                .pagenav-button-content {
                    height: 100%;
                    width: auto;
                    display: flex;
                    justify-content: center;
                }
            }
        }
        
    }
    .footerbar {
        position: absolute;
        width: 100%;
        top: 100%;
        left: 0;
    }
}
</style>
